import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { useAuth } from '../../Auth';
import { getUnifiedUser } from '../../gql/queries/getUnifiedUser';
import { tracker } from '../../utilities/tracker';

export const useUnifiedUserData = () => {
  const auth = useAuth();
  const isUserLoggedIn = !!auth?.profile;

  const {
    data: unifiedUserData,
    loading: unifiedUserLoading,
    error: unifiedUserError,
  } = useQuery(getUnifiedUser, {
    skip: !isUserLoggedIn,
    onError(error) {
      console.error('getUnifiedUser query failed:', error);
      tracker.track('Get Unified User Query Failed', { error });
    },
  });

  const unifiedUser = unifiedUserData?.unifiedUser || null;

  const unifiedUserId = useMemo(() => {
    return unifiedUser?.liveAttributes?.id || null;
  }, [unifiedUser?.liveAttributes?.id]);

  const unifiedChatToken = useMemo(() => {
    return unifiedUser?.chatToken || null;
  }, [unifiedUser?.chatToken]);

  return {
    unifiedUserData,
    unifiedUserLoading,
    unifiedUserError,
    unifiedUser,
    unifiedUserId,
    unifiedChatToken,
  };
};
